import { besoins } from './besoins'
import { ressources } from './ressources'
import { solutions } from './solutions'
import { tarifs } from './tarifs'

export const assoconnectMenu = [solutions, besoins, tarifs, ressources]
